var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CirclePlus"},[_c('Icon',{attrs:{"type":"cross"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }